import React from 'react'
import { Link, Imgix } from '@elements'

export const Combo = ({
  comboContent,
  comboHeadline,
  comboImage,
  callToActionGroup,
  comboLayout,
}) => {
  // typically, we would just use conditional classes
  // to restyle the layout, but there's too many differences for left vs. right
  // just easier to do a switch statement—it is statically rendered, so no
  // performance concerns for users
  switch (comboLayout) {
    case 'content-right':
      return (
        <section className="relative z-10 pb-32 lg:pb-48">
          <div className="container max-w-screen-xl">
            <div className="w-full max-w-sm mx-auto mt-48 md:mt-56 lg:mt-20 xl:mt-32 sm:max-w-md md:max-w-lg lg:max-w-none">
              <div className="bg-gray-100 shadow-md lg:flex">
                <div className="w-10/12 mx-auto lg:flex lg:items-center lg:w-1/3">
                  <Imgix
                    src={comboImage.mediaItemUrl}
                    alt={comboImage.altText}
                    sizes="(min-width: 1024px) 41.6vw, 100vw"
                    className="w-full h-auto overflow-hidden transform -translate-y-1/2 rounded-full lg:scale-125 xl:scale-125 lg:-translate-x-16 lg:translate-y-0"
                  />
                </div>
                <div className="items-start justify-center p-10 -mt-40 lg:w-2/3 xl:p-16 sm:-mt-48 lg:mt-0 lg:flex lg:flex-col">
                  <h2 className="font-sans text-3xl font-bold leading-snug tracking-wider uppercase sm:text-5xl lg:text-4xl xl:text-5xl text-brand-red sm:leading-tight">
                    {comboHeadline}
                  </h2>
                  <p className="max-w-6xl mt-2 text-lg leading-normal sm:mt-4 sm:text-2xl lg:text-xl xl:text-2xl sm:leading-snug">
                    {comboContent}
                  </p>
                  {callToActionGroup.ctaLinkText && (
                    <Link
                      to={callToActionGroup.ctaLinkUrl}
                      className="block px-6 pt-2 pb-1 mt-8 mb-2 mr-4 font-sans text-xl font-bold text-center text-gray-400 no-underline uppercase transition duration-200 border-4 lg:inline-block lg:mb-0 border-brand-yellow xl:text-3xl hover:bg-brand-yellow"
                    >
                      {callToActionGroup.ctaLinkText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    case 'content-left':
      return (
        <section className="relative z-10 pb-32 lg:pb-48">
          <div className="container max-w-screen-xl">
            <div className="w-full max-w-sm mx-auto mt-56 md:mt-64 lg:mt-48 lg sm:max-w-md md:max-w-lg lg:max-w-none">
              <div className="bg-gray-100 shadow-md lg:flex">
                <div className="w-10/12 mx-auto lg:flex lg:items-center lg:w-1/3 lg:order-last">
                  <Imgix
                    src={comboImage.mediaItemUrl}
                    alt={comboImage.altText}
                    sizes="(min-width: 1024px) 41.6vw, 100vw"
                    className="w-full h-auto overflow-hidden transform -translate-y-1/2 rounded-full lg:scale-125 xl:scale-125 lg:translate-x-16 lg:translate-y-0"
                  />
                </div>
                <div className="items-start justify-center p-10 -mt-40 xl:p-16 sm:-mt-48 lg:mt-0 lg:w-2/3 lg:flex lg:flex-col">
                  <h2 className="font-sans text-3xl font-bold leading-snug tracking-wider uppercase sm:text-5xl lg:text-4xl xl:text-5xl text-brand-red sm:leading-tight">
                    {comboHeadline}
                  </h2>
                  <p className="max-w-6xl mt-2 text-lg leading-normal sm:mt-4 sm:text-2xl lg:text-xl xl:text-2xl sm:leading-snug">
                    {comboContent}
                  </p>
                  {callToActionGroup.ctaLinkText && (
                    <Link
                      to={callToActionGroup.ctaLinkUrl}
                      className="block px-6 pt-2 pb-1 mt-8 mb-2 mr-4 font-sans text-xl font-bold text-center text-gray-400 no-underline uppercase transition duration-200 border-4 lg:inline-block lg:mb-0 border-brand-yellow xl:text-3xl hover:bg-brand-yellow"
                    >
                      {callToActionGroup.ctaLinkText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    default:
      return (
        <section className="relative z-10 pb-32 lg:pb-48">
          <div className="container max-w-screen-xl">
            <div className="w-full max-w-sm mx-auto mt-48 md:mt-56 lg:mt-20 xl:mt-32 sm:max-w-md md:max-w-lg lg:max-w-none">
              <div className="p-10 bg-gray-100 shadow-md">
                <p className="max-w-6xl text-lg leading-normal text-center sm:text-2xl lg:text-xl xl:text-2xl sm:leading-snug">
                  Drat! We don't have anything for that comboLayout{' '}
                  <span role="img" aria-label="Fret emoji">
                    😅
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>
      )
  }
}
